/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import './ReadOnlyRelationshipAccountList.scss';
import { object } from 'prop-types';
import React from 'react';

import { GroupedAccountList } from 'components/shared/GroupedAccountList/GroupedAccountList';
import { GroupedAccountListHeader } from 'components/shared/GroupedAccountList/GroupedAccountListHeader';
import { AccountList } from 'components/shared/GroupedAccountList/AccountList';
import { AccountListItem } from 'components/shared/GroupedAccountList/AccountListItem';
import { getAccountHeaderClassname } from 'components/shared/GroupedAccountList/util';
import AccountDisplay from 'components/shared/AccountDisplay/AccountDisplay';
import { ReactComponent as Check } from 'assets/icons/gva-check.svg';
import { ReactComponent as LockIcon } from 'assets/icons/lock-2.svg';
const ReadOnlyRelationshipAccountList = ({ accountGroups, customerName }) => (
  <div
    className="gva-accounts"
    data-testid={`${customerName.replace(/ /g, '-')}-accounts-list`}>
    <div className="gva-account-type-list">
      {Object.entries(accountGroups).map(([accountGroupName, accounts]) => (
        <GroupedAccountList
          groupClassification={getAccountHeaderClassname(accounts)}
          key={accountGroupName}>
          <GroupedAccountListHeader accountGroupName={accountGroupName} />
          <AccountList>
            {accounts.map((account) => (
              <AccountListItem key={account.accountId}>
                <AccountDisplay account={account} withLink={false} withOwners />

                {account.hasViewAccess ? (
                  <Check
                    className="view-access-indicator"
                    data-testid={`${account.accountNumber}-view-indicator-has-access`}
                  />
                ) : (
                  <span
                    className="no-access-text"
                    data-testid={`${account.accountNumber}-view-indicator-no-access`}>
                    <LockIcon />
                  </span>
                )}
              </AccountListItem>
            ))}
          </AccountList>
        </GroupedAccountList>
      ))}
      <div className="warning-text">
        You must provide access to at least one investment.
      </div>
    </div>
  </div>
);

ReadOnlyRelationshipAccountList.propTypes = {
  accountGroups: object
};

export default ReadOnlyRelationshipAccountList;
